module.exports = __webpack_public_path__ + "img/Comp-1.22bd11d4.gif";